import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import io from "socket.io-client";
import axios from "axios";
import Navbar from "../navbar/Navbar";

const socket = io("https://happyu.onrender.com");

export default function ChatPage() {
  const { room } = useParams();
  const currentUser = JSON.parse(localStorage.getItem("user"));
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState("");
  const [chatId, setChatId] = useState(null);
  const [otherName, setOtherName] = useState("");
  const messagesEndRef = useRef(null);
  const [userId, counsellorId] = room.split("-");

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    const loadChat = async () => {
      try {
        const res = await axios.post("https://happyu.onrender.com/chat/room", {
          userId,
          counsellorId,
        });
        setChatId(res.data._id);
        if (messages.length === 0) setMessages(res.data.messages || []);
        setOtherName(
          currentUser._id === res.data.userId
            ? "Doctor"
            : res.data.userName || "You"
        );
        socket.emit("joinRoom", { chatId: res.data._id });
      } catch (err) {
        console.error("Error loading chat:", err);
      }
    };
    loadChat();
  }, [userId, counsellorId]);

  useEffect(() => {
    socket.on("receiveMessage", (msg) => setMessages((prev) => [...prev, msg]));
    return () => socket.off("receiveMessage");
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const sendMessage = () => {
    if (!text.trim() || !chatId) return;
    socket.emit("sendMessage", {
      chatId,
      senderId: currentUser._id,
      senderName: currentUser.username,
      text,
    });
    setText("");
  };

  return (
    <>
      <div className="flex flex-col items-center min-h-screen pt-20 bg-gray-100">
        <div className="w-full max-w-2xl h-screen bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col relative">
          {/* Chat header */}
          <div className="bg-green-600 text-white text-lg font-semibold py-3 px-5 flex items-center justify-between shadow-md">
            <span>💬 Chat with {otherName}</span>
          </div>

          {/* Background and messages */}
          <div
            className="flex-1 p-4 overflow-y-auto  bg-cover bg-center space-y-3"
            style={{
              backgroundColor: "#e5ddd5",
              backgroundBlendMode: "overlay",
            }}
          >
            {messages.map((msg, idx) => {
              const isCurrentUser = msg.senderId === currentUser._id;
              return (
                <div
                  key={idx}
                  className={`flex ${
                    isCurrentUser ? "justify-end" : "justify-start"
                  }`}
                >
                  <div
                    className={`px-4 py-2 rounded-2xl shadow-sm text-sm max-w-[75%] break-words ${
                      isCurrentUser
                        ? "bg-green-500 text-white rounded-br-none"
                        : "bg-white text-gray-900 rounded-bl-none"
                    }`}
                  >
                    <div className="font-semibold mb-1 text-xs opacity-70">
                      {isCurrentUser ? "You" : "Doctor"}
                    </div>
                    <div>{msg.text}</div>
                  </div>
                </div>
              );
            })}
            <div ref={messagesEndRef} />
          </div>

          {/* Message input */}
          <div className="flex items-center gap-3 p-3 border-t bg-gray-50">
            <input
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              placeholder="Type a message"
              onKeyDown={(e) => e.key === "Enter" && sendMessage()}
              className="flex-1 p-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-green-500 text-sm bg-white"
            />
            <button
              onClick={sendMessage}
              className="bg-green-600 text-white px-5 py-2 rounded-full font-medium hover:bg-green-700 transition-transform active:scale-95"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
